
// Import JS Modules
import genericHelpers from './generic-helpers';

// -----------------------------------------------------------
//  ShallowComparatorMixin
// -----------------------------------------------------------
const ShallowComparatorMixin = {
  shouldComponentUpdate(nextProps, nextState) {
    return !genericHelpers.shallowObjectEquals(this.props, nextProps)
            || !genericHelpers.shallowObjectEquals(this.state, nextState);
  },
};

export default ShallowComparatorMixin;
